import { render } from "./SizeRichText.vue?vue&type=template&id=fe28ab56"
import script from "./SizeRichText.vue?vue&type=script&lang=js"
export * from "./SizeRichText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__